var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('HelpListPage',{attrs:{"id":"HELP_PAGE_COMMON","heading":_vm.$t('helpPage.commonPage.heading'),"title":_vm.$t('helpPage.commonPage.title'),"description":_vm.$t('helpPage.commonPage.description')}})}
var staticRenderFns = []

export { render, staticRenderFns }